export default {
  title: 'How processing fees work',
  how_it_works:
    'Stripe charges its fee to your platform on every online payment your restaurants take. The processing fee you set is what the restaurant pays for that payment. If it is higher than Stripe’s fee, you keep the difference as your margin. If it is lower, or you set none, you pay the difference yourself.',
  stripe_rates_link: 'See Stripe’s standard rates',
  example: {
    intro: 'Example: a {{total}} order paid by card. Stripe charges your platform {{stripe_fee}} ({{stripe_rate}}).',
    above: 'Your rate {{rate}}: the restaurant pays {{fee}}, you keep {{difference}}.',
    below: 'Your rate {{rate}}: the restaurant pays {{fee}}, you pay the {{difference}} difference.',
    none: 'No rate (0% margin): the restaurant pays nothing, you pay the full {{stripe_fee}}.',
    disclaimer:
      'Stripe’s fee here is its standard card rate in the EEA, for illustration. Your actual fee depends on the card, its country and your Stripe pricing.',
  },
};
